import { word } from "@modules/core/utils/i18n"
import { MediaType } from "@modules/sessionBlock/media/mediaTypes"
import { has } from "lodash"
import * as Yup from "yup"

export type MediaItemFormikType = {
  id?: string | null
  url?: string
  file?: File
  awsS3Key?: string
  type: MediaType
  isUploading?: boolean
  filename: string | null
}

export type MediaFormikType = { medias: MediaItemFormikType[] }

export function getMediaValidationSchema() {
  return Yup.object()
    .shape({
      url: Yup.string(),
      file: Yup.mixed(),
    })
    .test(
      "Youtube URL or Video File",
      word("sessionForm.blocks.add_media.missing_error"),
      (value) => has(value, "url") || has(value, "file"),
    )
}

export function getMediaBlockValidationSchema() {
  return Yup.object().shape({
    medias: Yup.array()
      .of(getMediaValidationSchema())
      .test("", word("sessionForm.blocks.add_media.wrong_quantity_of_media"), (value) => {
        return value && value.length > 0 && value.length <= 5
      }),
  })
}
